import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Helper } from '../classes/helper';

/**
 * Service for cumulative router data
 */
@Injectable({
	providedIn: 'root'
})
export class RouterDataService {
	// Cumulative router data
	protected data$: BehaviorSubject<{ [key: string]: any }> = new BehaviorSubject({});

	/**
	 * Constructor
	 */
	constructor(private router: Router, private route: ActivatedRoute) {
		this.subscribeRouterChange();
	}

	/**
	 * Getter for data
	 */
	get data(): { [key: string]: any } {
		return this.data$.getValue();
	}

	/**
	 * Setter for data
	 *
	 * @param value
	 */
	set data(value: { [key: string]: any }) {
		if (!value) {
			this.data$.next({});
		} else {
			this.data$.next(value);
		}
	}

	/**
	 * Getter for Observable of data
	 */
	public get dataObservable(): Observable<{ [key: string]: any }> {
		return this.data$.asObservable();
	}

	/**
	 * Subscribe router change
	 */
	private subscribeRouterChange() {
		// Subscribe NavigationEnd event from router
		this.router.events
			.pipe(
				filter((event) => event instanceof NavigationEnd),
				map(() => this.route.snapshot),
				map((currentRoute) => {
					// Init data
					const data = currentRoute.data ? JSON.parse(JSON.stringify(currentRoute.data)) : {};

					// Collect all data from all children
					while (currentRoute.firstChild) {
						if (currentRoute.firstChild.data) {
							// Deep merge with special handling for arrays
							Helper.mergeConfig(data, JSON.parse(JSON.stringify(currentRoute.firstChild.data)));
						}
						currentRoute = currentRoute.firstChild;
					}

					// Return cumulative router data
					return data;
				})
			)
			.subscribe((data) => {
				// Set current data
				this.data = data;
			});
	}
}
